import React, { useRef, useEffect } from 'react';
import { useLocation, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import ReactGA from 'react-ga';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';
import Booking from './views/Booking';
import LayoutBooking from './layouts/LayoutBooking';
import NewClient from './components/sections/NewCustomer';

// Initialize Google Analytics
ReactGA.initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal
      ref={childRef}
      children={() => (
        <Switch>
          <AppRoute exact path="/" component={Home} layout={LayoutDefault} />
          <AppRoute exact path="/booking" component={Booking} layout={LayoutBooking}/>
          <AppRoute exact path="/new-client" component={NewClient} layout={LayoutBooking}/>
        </Switch>
      )} />
  );
}

export default App;

// import React, { useRef, useEffect } from 'react';
// import { useLocation, Switch, Route } from 'react-router-dom';
// // import {Route from 'react-router-dom';
// import ScrollReveal from './utils/ScrollReveal';
// import ReactGA from 'react-ga';

// // Layouts
// import LayoutDefault from './layouts/LayoutDefault';

// // Views 
// import Home from './views/Home';
// import Signup from './views/Signup';

// // Initialize Google Analytics
// ReactGA.initialize(process.env.REACT_APP_GA_CODE);

// const trackPage = page => {
//   ReactGA.set({ page });
//   ReactGA.pageview(page);
// };

// const App = () => {

//   const childRef = useRef();
//   let location = useLocation();

//   useEffect(() => {
//     const page = location.pathname;
//     document.body.classList.add('is-loaded')
//     childRef.current.init();
//     trackPage(page);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location]);

//   return (
//     <ScrollReveal
//       ref={childRef}
//       children={() => (
//         <Switch>
//           <Route exact path="/" component={Home} layout={LayoutDefault} />
//           <Route exact path='/booking' component={Signup} />
//         </Switch>
//       )} />
//   );
// }

// export default App;